import { useLayoutEffect, useRef, useState } from "react";
import { MAIN_CONTENT_ID } from "common/constants";

/**
 * New look: the bot form sits inside the page's scroll container and fills
 * what is left of it, so its columns scroll on their own instead of the page.
 * Returns a ref for the form's root and the height that makes it fit.
 */
export const useFillHeight = (enabled: boolean) => {
  const ref = useRef<HTMLDivElement>(null);
  const [offset, setOffset] = useState(0);

  useLayoutEffect(() => {
    if (!enabled) return;
    const measure = () => {
      const element = ref.current;
      const container = document.getElementById(MAIN_CONTENT_ID);
      if (!element || !container) return;
      const next = Math.max(
        0,
        Math.round(
          element.getBoundingClientRect().top -
            container.getBoundingClientRect().top +
            container.scrollTop
        )
      );
      setOffset((prev) => (prev === next ? prev : next));
    };
    measure();
    const container = document.getElementById(MAIN_CONTENT_ID);
    const observer = new ResizeObserver(measure);
    if (container?.firstElementChild) {
      observer.observe(container.firstElementChild);
    }
    window.addEventListener("resize", measure);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, [enabled]);

  return {
    ref,
    height: enabled && offset ? `calc(100% - ${offset}px)` : undefined,
  };
};
